var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg117VideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492,254c11.046,0,20-8.954,20-20v-55.927c0-22.899-12.729-43.473-33.222-53.693c-20.49-10.22-44.585-8.011-62.875,5.766 l-0.522,0.393L354,183.388V159c0-44.112-35.888-80-80-80H80c-44.112,0-80,35.888-80,80v194c0,44.112,35.888,80,80,80h194 c44.112,0,80-35.888,80-80v-23.388l60.886,52.423l1.018,0.819c10.662,8.03,23.291,12.13,36.033,12.13 c9.118,0,18.295-2.101,26.842-6.364C499.271,378.4,512,357.826,512,334.927c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20 c0,7.749-4.14,14.439-11.073,17.897c-6.772,3.377-14.401,2.771-20.518-1.599L354,276.828v-40.656l86.409-74.398 c6.118-4.369,13.745-4.976,20.518-1.599C467.86,163.633,472,170.324,472,178.073V234C472,245.046,480.954,254,492,254z M314,353 c0,22.056-17.944,40-40,40H80c-22.056,0-40-17.944-40-40V159c0-22.056,17.944-40,40-40h194c22.056,0,40,17.944,40,40V353z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg117VideoCamera);
export default __webpack_public_path__ + "static/media/117-video-camera.6010ebb78f6d5d4048dcc6c7c75410f4.svg";
export { ForwardRef as ReactComponent };